"use strict";
//@ts-check
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.allClose = exports.allEq = exports.ravel = exports.extend = exports.binary_operation = void 0;
function binary_operation(A, B, func) {
    // Pointwise check for equality for arbitrary js arrays (without broadcasting)
    var C = [];
    var q = [[A, B, C, 0]];
    var seen;
    while (true) {
        var _next = q.pop();
        if (!_next)
            return true;
        var _a = __read(_next, 4), a = _a[0], b = _a[1], c = _a[2], depth = _a[3];
        if (Array.isArray(a) && Array.isArray(b) && a.length == b.length) {
            for (var i in a) {
                var c_i = [];
                c.push(c_i);
                q.push([a[i], b[i], c_i, depth + 1]);
            }
        }
        else
            c.push(func(a, b));
        if (depth > 10000 && Array.isArray(a)) { // Activate circular reference detection
            // Checking only A suffices (the other will exhaust otherwise)
            seen = /**@type {any[]}*/ (seen || []);
            if (seen.includes(a))
                throw new Error("Circular reference found. ".concat(a));
            seen[depth - 10000] = a;
        }
    }
}
exports.binary_operation = binary_operation;
;
function extend(listA, listB, chunkSize) {
    if (chunkSize === void 0) { chunkSize = 10000; }
    var i = 0;
    for (var i_1 = 0; i_1 < listB.length; i_1 += chunkSize) {
        i_1 = Math.min(i_1, listB.length);
        listA.push.apply(listA, __spreadArray([], __read(listB.slice(i_1, i_1 + chunkSize)), false));
    }
    return listA;
}
exports.extend = extend;
function ravel(A) {
    // Flatten js array
    var q = [[A, 0]], flat = [];
    var seen;
    var _loop_1 = function () {
        var _next = q.pop();
        if (!_next)
            return "break";
        var _a = __read(_next, 2), a = _a[0], depth = _a[1];
        if (depth > 10000 && Array.isArray(a)) { // Activate circular reference detection
            seen = /**@type {any[]}*/ (seen || []);
            if (seen.includes(a))
                throw new Error("Circular reference found. ".concat(a));
            seen[depth - 10000] = a;
        }
        if (Array.isArray(a)) {
            extend(q, a.map(function (v) { return [v, depth + 1]; }));
            return "continue";
        }
        flat.push(a);
    };
    while (true) {
        var state_1 = _loop_1();
        if (state_1 === "break")
            break;
    }
    return flat;
}
exports.ravel = ravel;
;
function allEq(A, B, nan_equal) {
    if (nan_equal === void 0) { nan_equal = false; }
    var different = new Error('');
    var func = function (a, b) {
        if (a !== b && !(nan_equal && Number.isNaN(a) && Number.isNaN(b)))
            throw different;
        return 0;
    };
    try {
        binary_operation(A, B, func);
    }
    catch (err) {
        if (err === different)
            return false;
        else
            throw err;
    }
    return true;
}
exports.allEq = allEq;
;
function allClose(A, B, rtol, atol, nan_equal) {
    if (rtol === void 0) { rtol = 1.e-5; }
    if (atol === void 0) { atol = 1.e-8; }
    if (nan_equal === void 0) { nan_equal = false; }
    var func = function (a, b) {
        if (Number.isFinite(a) && Number.isFinite(b))
            return Math.abs(a - b) <= atol + rtol * Math.abs(b);
        return (a == b) || (nan_equal && Number.isNaN(a) && Number.isNaN(b));
    };
    var different = new Error('');
    var wrapper = function (a, b) {
        if (!func(a, b))
            throw different;
        return 0;
    };
    try {
        binary_operation(A, B, wrapper);
    }
    catch (err) {
        if (err === different)
            return false;
        else
            throw err;
    }
    return true;
}
exports.allClose = allClose;
